<template>
    <editor
        v-bind="$attrs" v-on="$listeners"
        v-model="active_content"
        :api-key="api_key"
        @onChange="emitText"
        :id="element_id"
        :init="{
            plugins: 'lists link image paste help wordcount autoresize fullscreen code',
            toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | help | code',
            image_uploadtab: true,
            images_upload_handler: image_upload_handler,
            auto_focus: element_id,
            relative_urls: false,
            remove_script_host: false,
        }"
    />
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
export default {
    name: "WYSIWYG",
    inheritAttrs: false,
    components: { Editor },
    props: {
        'extensions': {
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
        'value':{
            type: String,
            required: false,
            default: function () {
                return null
            }
        },
        'element_id':{
            type: String,
            required: false,
            default: function () {
                return null
            }
        },
    },
    data() {
        return {
            active_content: this.value || null,
        }
    },
    computed: {
        is_readonly: function () {
            return this.$attrs['readonly']
        },
        api_key: function() {
            //return window.CONSTANTS.TINY_MCE_KEY
            return this.$page.tiny_mce_key
        }
    },
    methods: {
        emitText() {
            this.$emit('input', this.active_content)
        },
        getRandomFileName() {
            let timestamp = new Date().toISOString().replace(/[-:.]/g,"")
            let random = ("" + Math.random()).substring(2, 8)
            return timestamp + random;
        },
        image_upload_handler (blobInfo, success, failure, progress) {
            let regex_extension = /(?:\.([^.]+))?$/;
            let filename = blobInfo.filename()
            let extension = regex_extension.exec(filename)[1]
            let random_filename = this.getRandomFileName()
            let new_filename = !!extension ? `${random_filename}.${extension}` : random_filename
            let formData = new FormData();
            formData.append('file', blobInfo.blob(), new_filename);
            axios.post('generic_upload', formData)
                .then((response)=>{
                    if (!response.data.success) {
                        failure('Upload failed for unknown reason')
                        // this.$root.snackbar.error("Upload failed for unknown reason")
                        return;
                    }
                    success(response.data.location)
                })
                .catch((error)=>{
                    console.error(error)
                    failure(error.message)
                })


        },
    },

    watch: {
        'value': {  // Since we made our local variable the same as the incoming prop, we should update it if the prop changes too
            async handler(newVal, oldVal) {
                this.$set(this,'active_content',newVal)
            },
            deep: true
        },
    },
}
</script>
<style>
.v-sheet.v-card {
    box-shadow: none !important;
    -moz-box-shadow: none !important;
}
</style>
